import { PageBtn } from 'modules/components'
import { TrackExposure } from 'modules/analysis'

interface Props {
  className?: string
}

export function ContactBtn({ className }: Props) {
  return (
    <TrackExposure config={{ attr: { type: 'contact_btn' } }} withNavigate>
      <PageBtn className={className} href="/support/#support-contact-us">
        CONTACT US
      </PageBtn>
    </TrackExposure>
  )
}
